import { LinkOptions } from "./interfaces";

export const nodeWidth = 160;

export const ZOOM_STEP = 0.05;
export const ZOOM_SCALE_MIN = 0.5;
export const ZOOM_SCALE_MAX = 1.5;

export const DEFAULT_LINK_OPTIONS: LinkOptions = {
  linkOffsetStart: -4,
  linkOffsetEnd: 1,
  cornerRadius: 4,
};
